export function toNumber(v: unknown): number {
  if (v == null) return 0;
  if (typeof v === "number") return Number.isFinite(v) ? v : 0;

  if (typeof v === "string") {
    let s = v.trim();
    if (s.includes(",")) {
      s = s
        .replace(/[^\d,.-]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
    } else {
      s = s.replace(/[^\d.-]/g, "");
    }

    const n = parseFloat(s);
    return Number.isNaN(n) ? 0 : n;
  }

  return 0;
}

export function formatCurrencyBRL(v: unknown): string {
  if (v === null || v === undefined || v === "") return "-";
  const num = Number(v);
  if (Number.isNaN(num)) return "-";

  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

